<template>
  <div class="main">
    <van-nav-bar title="交存详情" left-arrow @click-left="onClickLeft" />
    <!-- <van-pull-refresh v-model="loading" @refresh="getDetail"> -->

    <div class="container">
      <div class="top">
        <div class="left">
          <p class="title">{{ currentData.wyqumc }}</p>

          <div class="hoster">
            <div class="yzmc">
              <span style="display:inline-block;width
              :45px
              ">业主：</span><span style="font-weight: 400">{{ currentData.yz }}</span>
            </div>
          </div>
        </div>

      </div>
      <div class="content">
        <p class="vote-time" style="margin: 0">房屋名称：</p>
        <p class="text">
          {{ currentData.fwmc || '--' }}
        </p>
        <!-- <p class="vote-time">具体楼栋:</p>
        <p class="text nomargin">{{ currentData.jtld }}</p> -->
        <p class="vote-time">建筑面积:</p>
        <p class="text nomargin">{{ currentData.jzmj || '--' }} m² </p>
        <p class="vote-time">通知单编号:</p>
        <p class="text nomargin">{{ currentData.tzdh || '--' }} </p>
        <p class="vote-time">交款类型:</p>
        <p class="text nomargin">{{ currentData.jklx || '--' }}</p>
        <p class="vote-time">应交金额:</p>
        <p class="money">
          ￥{{ currentData.yjje }}&nbsp;&nbsp;&nbsp;&nbsp;<span class="money-ch">{{ upperMoney }}</span>
        </p>
        <p class="vote-time">备注</p>
        <p class="text nomargin">
          {{ currentData.bz ? currentData.bz : "--" }}
        </p>
      </div>
      <div class="remark">
        <p style="font-size: 14px; margin:20px 0 0 0; color: #999998">说明：</p>

        <p class="remark-text">通过线下转款或到网点办理交款的业主，需持本通知单及银行交存回执到<span style="color:#FF6C19;">交款银行网点或代管机构</span>领取交存凭证。
        </p>
      </div>
    </div>

    <div class="footer" ref="tabbar">
      <div class="footer-detail">
        <div class="left">￥{{ currentData.yjje }}</div>
        <van-button :loading="loading" class="right" @click="handlerPay" v-show="!getting">获取付款码</van-button>
        <div class="right" v-show="getting">支付中...</div>
      </div>
    </div>

    <!-- <template v-else>
      <div class="container suc-sty">
        <div class="content-sub">
          <div class="top ">
            <div class="left">
              <p class="title">{{ currentData.wyqumc }}</p>
              <p class="suc-tip"><van-icon name="certificate" />已交存成功</p>
              <div class="hoster">
                <div class="yzmc">
                  <span style="display:inline-block;width
              :45px
              ">业主：</span><span style="font-weight: 400">{{ currentData.yz }}</span>
                </div>
              </div>
            </div>

          </div>
          <div class="content">
            <p class="vote-time" style="margin: 0">房屋名称：</p>
            <p class="text">
              {{ currentData.fwmc || '--' }}
            </p>

            <p class="vote-time">交款人:</p>
            <p class="text nomargin">{{ currentData.jkr || '--' }} </p>
            <p class="vote-time">交款方式:</p>
            <p class="text nomargin">{{ currentData.jkfs || '--' }} </p>
            <p class="vote-time">交款类型:</p>
            <p class="text nomargin">{{ currentData.jklx || '--' }}</p>
            <p class="vote-time">交存金额:</p>
            <p class="money">
              ￥{{ currentData.yjje }}&nbsp;&nbsp;&nbsp;&nbsp;<span class="money-ch">{{ upperMoney }}</span>
            </p>
            <p class="vote-time">专户银行:</p>
            <p class="text nomargin">{{ currentData.zhyh || '--' }}</p>

            <div class="info-item">
              <span class="desc">交存凭证：</span>
              <p class="detail">
                <span class="inner-pdf-icon"></span>{{ currentData.jcpz || "交款凭证.pdf" }}
                <span @click="emaillShow = true" class="send-sty">发送至邮箱</span>
              </p>
            </div>

          </div>
        </div>

      </div>

    </template> -->
    <!-- </van-pull-refresh> -->

    <!-- 发送至我得邮箱 -->
    <van-overlay :show="emaillShow">
      <div class="wrapper" @click.stop>
        <div class="block">
          <p class="title">是否发送至我的邮箱</p>
          <div class="middle-box">
            <span class="left">
              <span class="inner-pdf-icon"></span>
            </span>
            <span class="middle">{{
              "交款凭证.pdf"
            }}</span><span class="right">1.7M</span>
          </div>
          <div class="bot">
            <van-field v-model="emailInfo" type="email" label="邮箱：" />
          </div>
          <div class="btns">
            <span class="cancel-btn" @click="emaillShow = false">取消</span><span class="end-btn"
              @click="endEmailMet">发送</span>
          </div>
        </div>
      </div>
    </van-overlay>

  </div>
</template>
<script>
import api from "../../api/query";
import pay from '@/api/pay.js'
export default {
  name: "",
  components: {},
  data() {
    return {
      active: "1",
      currentId: "",
      currentData: {
      },
      upperMoney: "",
      getting: false,
      emaillShow: false,
      emailInfo: "",
      loading: false,
      payUrl: ""
    };
  },
  created() { },
  mounted() {
    this.currentId = this.$route.query.id 
    this.getDetail();

  },
  methods: {
    onClickLeft() {
      window.history.go(-1)
    },
    getDetail() {
      let params = {
        tzdId: this.currentId,
      };
      api
        .tzdH5(params)
        .then((res) => {

          if (res.data.code == 200) {
            this.currentData = res.data.data;
            this.upperMoney = this.upperNum(res.data.data.yjje)

          } else {
          }
        })
        .catch((err) => {

          this.$toast.fail({
            message: err,
          })
        });
    },
    handlerPay() {
      this.loading = true

      pay.crateOrderById(this.currentId).then(res => {
        this.loading = false
        if (res.data.code == 200 || res.code == 200) {
          let str = res.data.msg
          sessionStorage.setItem('payUrl', res.data.msg)
          location.href = '/pay' + '?id=' + this.currentId + '&total=' + this.currentData.yjje
        }
        else {
          let msg = encodeURI(res.data.msg || res.msg);
          return window.open("/repeatOrder?msg=" + msg, "_self");
        }
      }).catch(err => {
        this.loading = false
        this.$toast.fail({
          message: "交存失败，请稍后重试！",

        });
      })

    },
    endEmailMet() {
      console.log('===发送')
      if (
        /^([a-zA-Z\d][\w-]{2,})@(\w{2,})\.([a-z]{2,})(\.[a-z]{2,})?$/.test(
          this.emailInfo
        )
      ) {
        this.emaillShow = false;
        this.$toast.loading({
          message: "发送中...",
          forbidClick: true,
          loadingType: "spinner",
          overlay: true,
          duration: 0
        });


        pay.sendemail({
          email: this.emailInfo,
          tzdId: this.currentId
        })
          .then((res) => {
            this.$toast.clear();
            if (res.status == 200) {
              this.$toast.success('发送成功');
            } else {
              this.$toast.fail('发送失败');
            }
          })
          .catch(() => {
            this.$toast.clear();
            this.$toast.fail('发送失败');
          });
      } else {
        this.$toast.fail({
          message: "请输入正确邮箱地址！",
        });
        // this.$notify({ type: "danger", message: "请输入正确邮箱地址！" });
      }
    },
    upperNum(n) {
      let unit = "万仟佰拾亿仟佰拾万仟佰拾元角分", str = ""
      n = String(Math.round(n * Math.pow(10, 2)))
      unit = unit.substr(unit.length - n.length)
      for (let i = 0; i < n.length; i++) {
        str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
      }
      return str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整")
    },



  },
};
</script>

<style lang="less" scoped>
@font-face {
  font-family: "icomoon";
  // src: url("../../assets/fonts/icomoon.eot?3jk4dz");
  src: url("../../assets/fonts/icomoon.eot?3jk4dz");
  src: url("../../assets/fonts/icomoon.eot?3jk4dz#iefix") format("embedded-opentype"),
    url("../../assets/fonts/icomoon.ttf?3jk4dz") format("truetype"),
    url("../../assets/fonts/icomoon.woff?3jk4dz") format("woff"),
    url("../../assets/fonts/icomoon.svg?3jk4dz#icomoon") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

.van-nav-bar {
  position: sticky;
  top: 0;
  z-index: 9999;

}

.main {
  min-height: 100vh;
  background: linear-gradient(180deg,
      rgba(255, 216, 193, 0.42) 0%,
      rgba(244, 247, 249, 0.5) 100%);

  .container {
    padding: 20px;
    // position: relative;

    .top {
      display: flex;
      width: 100%;
      min-height: 120px;
      overflow: hidden;

      .left {
        // flex: 3;
        // width: 60%;

        .title {
          position: relative;
          width: 335px;
          min-height: 30px;
          margin: 0;
          font-size: 20px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #222120;
          line-height: 30px;
          z-index: 999;
        }

        .hoster {
          margin-top: 20px;
          width: 100%;
          min-height: 50px;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
          font-size: 14px;
          font-weight: 520;
          color: #222120;

          .yzmc {
            position: relative;
            width: 100%;
            min-height: 14px;
            font-size: 14px;
            font-weight: 550;
            color: #222120;
            line-height: 16px;
            z-index: 999;
          }

          .bottom {
            width: 100%;
            margin-top: 10px;
          }
        }
      }

      // .right {
      //   flex: 1;
      //   width: 40%;

      //   // margin-top: 20px;
      //   .images {
      //     width: 120px;
      //     height: 120px;
      //     background: transparent;
      //   }
      // }
    }

    .content {
      width: 100%;
      height: 100%;
      background: #ffffff;
      padding: 16px;
      // overflow: hidden;
      position: relative;

      &::after {
        content: "";
        display: inline-block;
        position: absolute;
        right: 0px;
        top: -94px;
        width: 120px;
        height: 120px;
        background: url("../../assets/img/img_money_detail.png");
        background-size: 120px 120px;
        z-index: 1;
      }

      .info-item {
        margin: 20px 0 16px 0;

        .desc {
          font-size: 16px;
          font-family: P ingFang SC-Semibold, PingFang SC;
          font-weight: 650;
          color: #4e4d4d;
          line-height: 19px;
        }

        .detail {
          margin: 3px 0 0;
          font-size: 14px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #4e4d4d;
          line-height: 22px;

          .left-money {
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ff3566;
            line-height: 19px;
          }

          .right-big-money {
            font-size: 12px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #999998;
            line-height: 14px;
            margin-left: 20px;
          }
        }
      }



      .money {
        width: 100%;
        height: 22px;
        font-size: 16px;
        font-weight: 600;
        color: #ff3566;
        line-height: 19px;
      }

      .money-ch {
        height: 17px;
        font-size: 12px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #999998;
        line-height: 14px;
      }

      .vote-time {
        font-size: 16px;
        font-weight: 600;
        color: #4e4d4d;
        line-height: 19px;
        margin-bottom: 16px;
      }

      .text {
        width: 100%;
        min-height: 16px;
        font-size: 14px;
        font-weight: 500;
        color: #4e4d4d;
        line-height: 18px;
      }

      .nomargin {
        margin: 0;
      }
    }

    // .main-box {
    //   min-height: 560px;

    //   &::after {
    //     content: "";
    //     display: inline-block;
    //     position: absolute;
    //     right: 0;
    //     top: -94px;
    //     width: 120px;
    //     height: 120px;
    //     background: url("../../assets/img/img_money_detail.png");
    //     background-size: 120px 120px;
    //     z-index: 1;
    //   }
    // }

    .remark {
      width: 100%;
      min-height: 40px;
      margin-bottom: 50px;
    }
  }

  .footer {
    position: fixed;
    bottom: 0px;
    width: 100%;
    height: 60px;
    background-color: #fff;

    box-shadow: 11px 20px 23px 15px rgba(0, 0, 0, 0.05);

    .footer-detail {
      margin: 0 20px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        min-width: 20px;
        height: 28px;
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ff3566;
        line-height: 23px;
      }

      .right {
        width: 110px;
        height: 42px;
        text-align: center;
        line-height: 42px;
        color: #fff;
        background: linear-gradient(133deg, #ff6c19 0%, #ffa370 100%);
        border-radius: 21px 21px 21px 21px;
      }
    }
  }
}

.remark-text {
  font-size: 14px;
  font-weight: 500;
  color: #4e4d4d;
  line-height: 26px;
  margin: 10px 0 0 0;
}

.suc-tip {
  font-size: 16px;
  font-weight: 600;

  margin: 0;
}

.van-icon-certificate {
  color: #17db17;
  font-weight: 600;
  font-size: 18px;
  margin-right: 2px;
}

.inner-pdf-icon {
  margin-right: 3px;
  vertical-align: middle;

  &::after {
    content: "\eadf";
    font-family: "icomoon";
    font-size: 18px;
    font-weight: 600;
    color: #dd0d0d;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 320px;
  background-color: #fff;
  color: #999;

  .title {
    font-size: 20px;
    color: #000000;
    font-weight: 800;
    text-align: center;
  }

  .middle-box {
    display: flex;
    height: 46px;
    line-height: 46px;
    padding: 0 10px;

    .left {
      width: 46px;

      .inner-pdf-icon {
        &::after {
          content: "\eadf";
          font-family: "icomoon";
          font-size: 42px;
          font-weight: 400;
          color: #dd0d0d;
        }
      }
    }

    .middle {
      flex: 1;
      line-height: 41px;
      padding-top: 4px;
      padding-left: 4px;

      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
    }

    .right {
      width: 60px;
      text-align: center;
    }
  }

  .bot {
    margin-bottom: 20px;

    ::v-deep {
      .van-cell.van-field {
        line-height: 28px;
      }

      .van-field__label {
        width: 46px !important;
        font-size: 16px;

        span {
          display: inline-block;
          width: 100%;
          white-space: nowrap;
        }
      }

      .van-cell__value.van-field__value {
        border: 1px solid #999;
        padding-left: 10px;
      }
    }
  }

  .btns {
    display: flex;
    margin-top: 10px;
    height: 42px;
    line-height: 42px;
    border-top: 1px solid rgb(202, 197, 197);
    font-size: 18px;
    font-weight: 500;
    text-align: center;

    .cancel-btn,
    .end-btn {
      width: 50%;
    }

    .cancel-btn {
      border-right: 1px solid rgb(202, 197, 197);
    }

    .end-btn {
      color: #ff6c1a;
    }
  }
}

.suc-sty {
  .main-box {
    min-height: 560px;
  }

  .content-sub {
    .top-box {
      h3 {
        margin-bottom: 0;
      }

      p {
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        margin: 0;

        &.suc-tip {
          font-size: 16px;
          font-weight: 600;
        }
      }

      .van-icon-certificate {
        color: #17db17;
        font-weight: 600;
        font-size: 18px;
        margin-right: 2px;
      }
    }
  }

  .send-sty {
    float: right;

    display: inline-block;
    padding: 0 8px;
    height: 26px;
    background-color: #ff6c1a;
    color: #fff;
    line-height: 24px;
    border-radius: 4px;
  }
}
</style>
